import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import ImageLoad from 'components/ImageLoad';
import SliderProductsContainer from 'containers/SliderProducts';
import Link from 'components/Link';
import tagManager from 'services/TagManager';
import { sliderProductsTxt } from 'config/translate/variables';
import WrapperOptimizer from "components/WrapperOptimizer";
import style from './style.scss';//NOSONAR

const SliderProductsBanner = ({ item }) => {
    const collection = item.group.collection && item.group.collection.length ? item.group.collection[0] : false;
    const [visible, setVisible] = useState(true);
    const [gtmData, setGtmData] = useState({})

    if (!collection || !collection.id) return '';

    const [styleTop, setStyle] = useState({});
    const id = "H:" + collection.id;
    const customStyle = {
        backgroundColor: item.group.background_color
    };

    useEffect(() => {
        promotionView()

        if(typeof window !== 'undefined'){
            window.addEventListener('resize', applyStyleTop);
            promotionView();
        }

        applyStyleTop();

        return function cleanup(){
            window.removeEventListener('resize', applyStyleTop);
        }
    },[]);

    const applyStyleTop = () => {
        if (typeof window !== 'undefined' && window.innerWidth < 840) {
            if (item.group.background_color === '#FFFFFF' && item.group.font_color === '#000000') {
                setStyle({})
            } else {
                setStyle({
                    backgroundColor: item.group.background_color,
                    color: item.group.font_color,
                });
            }
        } else {
            setStyle({});
        }
    };

    const promotionView = () => {
        const _imageDesktop = item.group && item.group.image_desktop ? item.group.image_desktop : '';
        const _imageMobile = item.group && item.group.imagen_mobile ? item.group.imagen_mobile : '';

        if(!(_imageDesktop && _imageDesktop.url) && !(_imageMobile && _imageMobile.url)) return false;

        item.id = _imageDesktop ? _imageDesktop.url.split('/').pop() : _imageMobile.url.split('/').pop();

        const promo = {
            id: item.id,
            name: `Home - ${item.title || ''}`,
            position: item.countSliderProductsBanner ? `slot${item.countSliderProductsBanner}` : 'slot0',
            creative: `Vitrina ${item.shelfIsland || ''}- ${item.title || ''}`,
            type: 'shelfBannerSlider'
        }

        return setGtmData(promo)
    }

    const promotionClick = (images, title) => {
        if (typeof window !== 'undefined' && window.innerWidth <= 839) {
            images.id = images[839] ? images[839].split('/').pop() : '';
        } else {
            images.id = images[1440] ? images[1440].split('/').pop() : '';
        }
        const promo = {
            id: images.id,
            title: 'Home - ' + title,
            position: item.countSliderProductsBanner ? 'slot'+item.countSliderProductsBanner : 'slot0',
            creative: `Vitrina ${item.shelfIsland || ''}- ${item.title || ''}`
        }
        tagManager.promotionsClick(promo);
    }

    const interactionClick = (title) => {
        tagManager.clickLink(sliderProductsTxt.viewMore,'Products-Banner-Slider',title);
    }

    const imageMobile = item.group && item.group.imagen_mobile ? item.group.imagen_mobile : '';
    const imageDesktop = item.group && item.group.image_desktop ? item.group.image_desktop : '';
    const altDescription = imageDesktop.alt || imageMobile.alt;
    const imageResponsive = { 839: imageMobile ? imageMobile.url : '', 1440: imageDesktop ? imageDesktop.url : ''};

    const callbackNotProducts = (visibility = false) => {
        setVisible(visibility);
    };

    return (
        <section
            className={'slider-products-banner' + (visible ? ' show' : '')}>
            <div className="slider-products-banner-top" style={styleTop}>
                <h1 className="slider-products-banner-title" style={styleTop}>
                    {item.title}
                </h1>
                <Link
                    className="new-link home-section-link" 
                    style={styleTop} 
                    onClick={() => interactionClick(item.title)}
                    to={item.group.url} 
                    target={item.group.url_target}>
                    {sliderProductsTxt.viewMore}
                </Link>
            </div>
            <div className="slider-banner-products">
                {(imageMobile.url || imageDesktop.url) && (
                    <Link to={item.group.url} onClick={() => promotionClick(imageResponsive, item.title)} target={item.group.url_target} className="slider-banner-products-wrap" style={customStyle} >
                        {(imageDesktop || imageMobile) && (
                            <ImageLoad src={imageMobile.url || imageDesktop.url} srcSet={imageResponsive} alt={altDescription} spinner={true} gtmData={gtmData} />
                        )}
                    </Link>
                )}

                <WrapperOptimizer typeComponent="home_sliders_products">
                    {(data) => {
                        return (<SliderProductsContainer
                            options={{ collections: id, position: item.countSliderProductsBanner, filter: item.group.sales_channel}}
                            callbackNotProducts={callbackNotProducts}
                            listTitle={'Vitrina ' + item.shelfIsland + ' - ' + (item.title ? item.title : item.id)}
                            campaignData={data}
                        />)
                    }}
                </ WrapperOptimizer>
            </div>
        </section>
    )
}

SliderProductsBanner.propTypes = {
    item: PropTypes.object
}

export default SliderProductsBanner;
